import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSubTitle } from "../stores/AppReducer";
import Paragraph from "./Paragraph";
import { useParams } from "react-router-dom";
import { getArticle, getIndex } from "../services/newsService";
import { INews } from "../interfaces/News";
import type { AppDispatch, IApplicationState } from "../stores/AppStore";

function News() {
    const dispatch = useDispatch<AppDispatch>();
    const app = useSelector((appState: IApplicationState) => appState.app);
    const params = useParams();
    let article: string;
    article = params.idx ? params.idx.replace(/:/, "") : "idx";
    useEffect(() => {
        dispatch(setSubTitle("AKTUELL"));
        dispatch(getIndex(null));
    }, []);
    useEffect(() => {
        if (article !== "idx" && app.news.length > 0) {
            const a = app.news.find((n: INews) => n.id === article);
            if (a?.content === undefined) {
                dispatch(getArticle(article)).then((res: any) => {
                    if (res.type === "get/article/fulfilled") {
                        dispatch(setSubTitle(res.payload.data.title));
                    }
                }); 
            }
        } else {
            dispatch(setSubTitle("AKTUELL"));
        }
    }, [article, app.news]);
    const renderShortArticle = (art: INews) =>  {
        return (
            <Paragraph key = {art.id} id={art.id} className={"paragraph"} >
                <h4>{art.title}</h4>
                <span className="released">{art.date.toLocaleDateString()}</span>
                <div className="short_article">
                    {art.image && <img src = {art.image} title="BILD" />}
                    {art.description}
                </div>
            </Paragraph>
        ); 
    }
    const renderNewsPage = () => {
        return (
            <div className="news_paper">
                {app.news.map(renderShortArticle)}
            </div>
        );

    };
    const renderArticle = (art: INews) => {
        return art ? (
            <Paragraph key = {art.id} id={art.id} className={"paragraph"} long={true}>
                <h3>{art.subTitle}</h3>
                <span className="released">Veröffentlicht: {art.date.toLocaleDateString()}</span>
                <div className="article">
                    {art.image && <img src = {art.image} />}
                    <div dangerouslySetInnerHTML={{__html: art.content}}/>
                </div>
            </Paragraph>
        ) : (null);
    };
    return (app.news.length > 0) ?
    (
        <div className="">
            {article === 'idx' ?  renderNewsPage() : renderArticle(app.news.find((n: INews) => n.id === article))}
            <div className = 'clear'/>
        </div>
    ) : (null);
}
export default News;
